import {
    IconCallLandlineRegular,
    IconChevronLeftRegular,
    IconListRegular,
    IconMobileDeviceRegular,
    IconSmsRegular,
    NavigationBar,
    Text2,
    Text3,
    Text6,
    ThemeVariant,
    skinVars,
} from '@telefonica/mistica';
import React, { useEffect, useRef, useState } from 'react';
import DetailConsumptionCard from '../DetailConsumptionCard';
import DetailsConsumptionHeaderTab from '../DetailsConsumptionHeaderTabs';
import './index.scss';
import { t } from 'i18next';
import { formatMobileNumber } from '../../utils/dataTransformation/unitsConversion';
import { getStringCycle } from '../../utils/dataTransformation/dateConversions';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getPhoneById } from '../../utils/dataTransformation/productConsumption';
import { isWebviewAndroid, isWebviewIOS } from '../../utils/navigation/controlDevices';
import BreadCrumbsWrapper from '../BreadcrumbsWrapper';
import { useConfigureLineContext } from '../../context/configure-line-context/ConfigureLineContext';

export interface DetailsConsumptionHeaderData {
    setView: Function;
    activeView: any;
    dataDetail: any;
    setPage: any;
    setError: any;
}

export const DetailsConsumptionHeader: React.FC<DetailsConsumptionHeaderData> = ({
    setView,
    activeView,
    dataDetail,
    setPage,
    setError,
}: DetailsConsumptionHeaderData) => {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const [isMobile] = useState(dataDetail.isMobile);
    const [sharedData] = useState(dataDetail.datasharing);
    const prevScrollY = useRef(0);
    const [goingUp, setGoingUp] = useState(false);
    const card: any = useRef(null);
    const tabs: any = useRef(null);
    const blueCard: any = useRef(null);
    const [viewCard, setViewCard] = useState(true);
    const [topSticky, setTopSticky] = useState(0);
    const { isConvergent } = useConfigureLineContext();

    let cicloInfo: any;
    if (dataDetail) {
        cicloInfo = getStringCycle(dataDetail.cycleStarts, dataDetail.cycleEnds);
    }

    let titleBreadcrumb: string;

    const _storage = window.localStorage.getItem('storages');
    titleBreadcrumb = getPhoneById(JSON.parse(_storage!), params.get('productPsId')!);

    useEffect(() => {
        setTopSticky(-(tabs.current.offsetTop - 16));
        const handleScroll = () => {
            const heightCard = document.getElementsByClassName('DetailConsumptionCard')[0]?.clientHeight;
            const currentScrollY = window.scrollY;
            if (currentScrollY > heightCard) {
                setGoingUp(false);
                card.current.style.display = 'none';
                blueCard.current.style.paddingBottom = '16px';
            } else {
                setGoingUp(true);
                if (card.current) {
                    card.current.style.display = 'block';
                    blueCard.current.style.paddingBottom = '48px';
                }
            }
            prevScrollY.current = currentScrollY;
        };

        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, [goingUp, card, setViewCard]);

    const manageContent = (ev: string) => {
        setError(false);
        setView(ev);
    };

    const getRootPath = () => {
        return window.location.pathname.includes('phone') ? 'phone' : 'mobile';
    };

    return (
        <div className='Details-consumption-header' style={{ top: topSticky }}>
            <div
                className='Details-consumption-header__blue'
                style={{
                    background: skinVars.colors.background,
                    borderBottom: `1px solid ${skinVars.colors.divider}`,
                }}
                ref={blueCard}
            >
                {!(isWebviewAndroid || isWebviewIOS) && (
                    <>
                        <div className='Details-consumption-header__blue-navigationBar'>
                            <NavigationBar
                                onBack={() => {
                                    navigate(-1);
                                }}
                                title={t('returnDetailConsumption')}
                            />
                        </div>
                        <div className='Details-consumption-header__blue-return'>
                            <div
                                className='Details-consumption-header__blue-return-cursor'
                                onClick={() => {
                                    navigate(-1);
                                }}
                            >
                                <div className='Details-consumption-header__blue-return-icon'>
                                    <IconChevronLeftRegular color={skinVars.colors.neutralHigh} size={20} />
                                </div>
                                <Text2 medium color={skinVars.colors.neutralHigh}>
                                    {t('returnResponsive')}
                                </Text2>
                            </div>
                        </div>
                    </>
                )}
                <div className='Details-consumption-header__blue-breadcrumbs'>
                    <ThemeVariant>
                        <BreadCrumbsWrapper
                            title={t('returnDetailConsumption')}
                            breadcrumbs={
                                !isConvergent
                                    ? [{ url: '/home', title: 'Inicio' }]
                                    : [
                                          { url: '/home', title: 'Inicio' },
                                          {
                                              url: `/${getRootPath()}?productPsId=${params.get('productPsId')}`,
                                              title: titleBreadcrumb,
                                          },
                                      ]
                            }
                        />
                    </ThemeVariant>
                </div>
                <div className='Details-consumption-header__mobile'>
                    <Text3 regular color={skinVars.colors.textPrimary}>
                        {formatMobileNumber(dataDetail.number)}
                    </Text3>
                </div>
                <div className='Details-consumption-header__cycle'>
                    <Text6 color={skinVars.colors.textPrimary}>{cicloInfo}</Text6>
                </div>
                <div
                    ref={tabs}
                    className={
                        isMobile
                            ? 'Details-consumption-header__tabs'
                            : 'Details-consumption-header__tabs Details-consumption-header__tabs--mobile'
                    }
                >
                    {isMobile ? (
                        <>
                            <DetailsConsumptionHeaderTab
                                icon={
                                    <IconMobileDeviceRegular
                                        size={24}
                                        color={
                                            activeView === 'DATA'
                                                ? skinVars.colors.controlActivated
                                                : skinVars.colors.neutralHigh
                                        }
                                    />
                                }
                                text={t('dataDetails')}
                                isActive={activeView === 'DATA'}
                                setView={manageContent}
                                setActive={'DATA'}
                            ></DetailsConsumptionHeaderTab>
                            <DetailsConsumptionHeaderTab
                                icon={
                                    <IconCallLandlineRegular
                                        size={24}
                                        color={
                                            activeView === 'VOICE'
                                                ? skinVars.colors.controlActivated
                                                : skinVars.colors.neutralHigh
                                        }
                                    />
                                }
                                text={t('callsDetails')}
                                isActive={activeView === 'VOICE'}
                                setView={manageContent}
                                setActive={'VOICE'}
                            ></DetailsConsumptionHeaderTab>
                            <DetailsConsumptionHeaderTab
                                icon={
                                    <IconSmsRegular
                                        size={24}
                                        color={
                                            activeView === 'SMS'
                                                ? skinVars.colors.controlActivated
                                                : skinVars.colors.neutralHigh
                                        }
                                    />
                                }
                                text={t('smsDetails')}
                                isActive={activeView === 'SMS'}
                                setView={manageContent}
                                setActive={'SMS'}
                            ></DetailsConsumptionHeaderTab>
                            <DetailsConsumptionHeaderTab
                                icon={
                                    <IconListRegular
                                        size={24}
                                        color={
                                            activeView === 'Otros'
                                                ? skinVars.colors.controlActivated
                                                : skinVars.colors.neutralHigh
                                        }
                                    />
                                }
                                text={t('othersDetails')}
                                isActive={activeView === 'Otros'}
                                setView={manageContent}
                                setActive={'Otros'}
                            ></DetailsConsumptionHeaderTab>
                        </>
                    ) : (
                        <>
                            <DetailsConsumptionHeaderTab
                                icon={
                                    <IconCallLandlineRegular
                                        size={24}
                                        color={
                                            activeView === 'VOICE'
                                                ? skinVars.colors.controlActivated
                                                : skinVars.colors.neutralHigh
                                        }
                                    />
                                }
                                text={t('callsDetails')}
                                isActive={activeView === 'VOICE'}
                                setView={manageContent}
                                setActive={'VOICE'}
                            ></DetailsConsumptionHeaderTab>
                            <DetailsConsumptionHeaderTab
                                icon={
                                    <IconListRegular
                                        size={24}
                                        color={
                                            activeView === 'Otros'
                                                ? skinVars.colors.controlActivated
                                                : skinVars.colors.neutralHigh
                                        }
                                    />
                                }
                                text={t('othersDetails')}
                                isActive={activeView === 'Otros'}
                                setView={manageContent}
                                setActive={'Otros'}
                            ></DetailsConsumptionHeaderTab>
                        </>
                    )}
                </div>
            </div>
            {viewCard && (
                <div className='Details-consumption-header-card' ref={card}>
                    <DetailConsumptionCard
                        sharedData={sharedData}
                        dataDetail={dataDetail}
                        activeView={activeView}
                        isMobile={isMobile}
                        setError={setError}
                    ></DetailConsumptionCard>
                </div>
            )}
        </div>
    );
};

export default DetailsConsumptionHeader;
